import script from "./DatePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=2a0cab66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a0cab66"]])

export default __exports__